import request from '@/utils/request'

export function login(data) {
  return request({
    url: '/auth/login',
    method: 'post',
    data
  })
}

export function autoLogin() {
  return request({
    url: '/auth/auto-login',
    method: 'post'
  })
}

export function getInfo() {
  return request({
    url: '/auth/user',
    method: 'get'
  })
}

export function logout() {
  return request({
    url: '/auth/logout',
    method: 'post'
  })
}

export function getUsers(query) {
  return request({
    url: '/users',
    method: 'get',
    params: query
  })
}

export function deleteUsers(ids) {
  return request({
    url: `/users/${ids}`,
    method: 'delete'
  })
}

export function addUsers(data) {
  return request({
    url: '/users',
    method: 'post',
    data
  })
}

export function updateUsers(uuid, data) {
  return request({
    url: `/users/${uuid}`,
    method: 'put',
    data
  })
}

export function getUser(uuid) {
  return request({
    url: `/users/${uuid}`,
    method: 'get'
  })
}

export function resetPassword(data) {
  return request({
    url: '/users/reset-pwd',
    method: 'post',
    data
  })
}

export function getUserOptions() {
  return request({
    url: '/users/options',
    method: 'get'
  })
}

export function getNotInOptions(query) {
  return request({
    url: '/users/notInOptions',
    method: 'get',
    params: query
  })
}

export function getWechatBindQrCode(query) {
  return request({
    url: '/users/getWechatBindQrCode',
    method: 'get',
    params: query
  })
}
export function getUserConfig() {
  return request({
    url: '/setting/show/ui-theme',
    method: 'get'
  })
}

export function postUserConfig(data) {
  return request({
    url: '/setting/ui-theme',
    method: 'post',
    data
  })
}

export function getBindTypeOptions() {
  return request({
    url: '/user-bind/options',
    method: 'get'
  })
}

// 获取短信码
export function getSms(data) {
  return request({
    url: '/auth/sendSms',
    method: 'post',
    data
  })
}
